import { render, staticRenderFns } from "./ElLoader.vue?vue&type=template&id=5af53f02&scoped=true&"
import script from "./ElLoader.vue?vue&type=script&lang=js&"
export * from "./ElLoader.vue?vue&type=script&lang=js&"
import style0 from "./ElLoader.vue?vue&type=style&index=0&id=5af53f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af53f02",
  null
  
)

export default component.exports